import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

	SignOut: {
		k: "header.toolbar.signout",
		v: "Sign Out"
	}

});



// WEBPACK FOOTER //
// ./src/panels/header/Header.labels.ts